module.exports = __webpack_public_path__ + "img/hermelin_brand_logo.f481d9f1.png";